import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { useListPropertyContext } from '../../../../../contexts/ListPropertyContext';
import { reusableTextFieldStyles } from '../../../../../components/ReusableTextField/ReusableTextField.styles';

const FeaturesSection = () => {
  const { formData, updateFormData } = useListPropertyContext();

  // Generate number options
  const generateNumberOptions = (min, max) => {
    return Array.from({ length: max - min + 1 }, (_, i) => String(min + i));
  };

  const floorsOptions = generateNumberOptions(1, 15);
  const parkingSpacesOptions = generateNumberOptions(1, 4);
  const bathroomsOptions = generateNumberOptions(1, 15);
  const balconiesOptions = generateNumberOptions(1, 4);

  const furnishingStatusOptions = ['Furnished', 'Unfurnished', 'Semi-Furnished'];
  const conditionOptions = ['Excellent', 'Great', 'Good', 'Adequate', 'Poor'];

  const handleFloorsChange = (event) => {
    const value = event.target.value;
    updateFormData('floors', value || '');
  };

  const handleParkingSpacesChange = (event) => {
    const value = event.target.value;
    updateFormData('parkingSpaces', value || '');
  };

  const handleBedroomsChange = (event) => {
    const value = event.target.value;
    updateFormData('bedrooms', value || '');
  };

  const handleBathroomsChange = (event) => {
    const value = event.target.value;
    updateFormData('bathrooms', value || '');
  };

  const handleFurnishingStatusChange = (e) => {
    updateFormData('furnishingStatus', e.target.value);
  };

  const handleBalconiesChange = (event) => {
    const value = event.target.value;
    updateFormData('balconies', value || '');
  };

  const handleConditionChange = (e) => {
    updateFormData('condition', e.target.value);
  };

  const textFieldStyles = reusableTextFieldStyles('#1F1F1F');

  return (
    <Grid container spacing={2}>
      {/* Row 1 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Floors"
          value={formData.floors || ''}
          onChange={handleFloorsChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {floorsOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Parking Spaces"
          value={formData.parkingSpaces || ''}
          onChange={handleParkingSpacesChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {parkingSpacesOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {/* Row 2 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Number of Bedrooms"
          value={formData.bedrooms || ''}
          onChange={handleBedroomsChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
            <MenuItem key={num} value={String(num)}>
              {num}
            </MenuItem>
          ))}
          <MenuItem value="10+">10+</MenuItem>
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Number of Bathrooms"
          value={formData.bathrooms || ''}
          onChange={handleBathroomsChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {bathroomsOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {/* Row 3 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Furnishing Status"
          value={formData.furnishingStatus}
          onChange={handleFurnishingStatusChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {furnishingStatusOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Number of Balconies"
          value={formData.balconies || ''}
          onChange={handleBalconiesChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {balconiesOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {/* Row 4 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select
          fullWidth
          label="Condition"
          value={formData.condition}
          onChange={handleConditionChange}
          sx={textFieldStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDown,
          }}
        >
          {conditionOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default FeaturesSection;

